
  import { defineComponent, PropType } from 'vue';
  import moment from 'moment';

  import Constants from '@/common/constants';

  import DashboardsCalendar from './DashboardsCalendar.vue';

  export default defineComponent({
    name: 'DashboardsChartsBlock',
    components: {
      DashboardsCalendar,
    },
    props: {
      calendarParams: {
        type: Object as PropType<Record<string, string | number | boolean>>,
      },
      isChartVisible: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      threeMonthsNavigationDate(): string {
        return moment().subtract(1, 'month').startOf('month').format(Constants.DATE_FORMATS['YYYY-MM-DD']);
      },
    },
  });
